import React, { useEffect, useRef, useState, useMemo } from "react";
import { LiaSearchSolid } from "react-icons/lia";
import debounce from "lodash.debounce";

function PharmacySearch({ searchValue, setSearchValue, placeholder = "Search by pharmacy name..." }) {
  const inputRef = useRef(null);
  const [localValue, setLocalValue] = useState(searchValue);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Sync if parent resets the value
  useEffect(() => {
    setLocalValue(searchValue);
  }, [searchValue]);

  const setSearchValueRef = useRef(setSearchValue);
  setSearchValueRef.current = setSearchValue;

  const debouncedSet = useMemo(
    () => debounce((val) => setSearchValueRef.current(val), 300),
    [],
  );

  useEffect(() => {
    return () => debouncedSet.cancel();
  }, [debouncedSet]);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setLocalValue(val);
    debouncedSet(val);
  };

  return (
    <div className="inputDiv">
      <input
        id="searchPharmacy"
        name="searchPharmacy"
        type="text"
        className="searchPatient"
        placeholder={placeholder}
        value={localValue}
        onChange={handleInputChange}
        autoComplete="off"
        ref={inputRef}
      />
      <span className="searchIcon">
        <LiaSearchSolid size={15} className="icons-color" />
      </span>
    </div>
  );
}

export default PharmacySearch;
